import { render } from "./infoBox.vue?vue&type=template&id=6fcae86a&scoped=true"
import script from "./infoBox.vue?vue&type=script&lang=js"
export * from "./infoBox.vue?vue&type=script&lang=js"

import "./infoBox.vue?vue&type=style&index=0&id=6fcae86a&lang=scss&scoped=true"

import exportComponent from "/home/forge/konfigurator.loewe-zaun.de/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcae86a"]])

export default __exports__